import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-page-not-found',
	template: `<div style="margin:5em; text-align:center"><h1>Diese Seite wurde leider nicht gefunden</h1></div>`
})
export class PageNotFoundComponent {

	constructor() {}
}
